// Players are created directly at contractSigned once a CRM-sourced contract
// is fully signed (see functions/index.js adminCoSignContract). Everything
// before that — Prospect through Player Accepted, plus contract sending and
// signing itself — lives in the CRM lead pipeline (see utils/leadStages.js).
// Quote/invoice generation happens after this point and is optional; it no
// longer gates a stage of its own.
// `order` is spaced out (100s) rather than sequential so an academy-defined
// custom stage (see customPlayerStages, StagesContext) can be inserted at
// any point in the pipeline by picking a value between two of these,
// without renumbering anything here. isSystem stages carry hardcoded
// behavior elsewhere (functions/index.js — conversion, automation gating,
// payment tracking), keyed on their literal `key`, so an admin can relabel
// one (change what it's called) but never delete it or change its key.
//
// `unassigned` and `awaitingAcademyContract` only ever appear on players
// sourced through an agency-type tenant (e.g. PLYRMATCH) — see
// utils/tenantType.js. A directly-recruited academy player never passes
// through them; they're created straight at contractSigned as before.
// Deliberately absent from getValidStageKeys' systemKeys list in
// functions/index.js, so staff can't drag a card into/out of them by
// hand — only the agency co-sign and placement flows may set them.
export const STAGES = [
  { key: 'unassigned',              label: 'Unassigned',                     order: 10,  isSystem: true, bg: '#f5f3ff', color: '#8b5cf6' },
  { key: 'awaitingAcademyContract', label: 'Awaiting Academy Contract',      order: 50,  isSystem: true, bg: '#fffbeb', color: '#f59e0b' },
  { key: 'contractSigned',          label: 'Contract Signed',                order: 100, isSystem: true, bg: '#ecfdf5', color: '#10b981' },
  { key: 'paymentMade',             label: 'Payment Made',                   order: 200, isSystem: true, bg: '#f0fdfa', color: '#14b8a6' },
  { key: 'active',                  label: 'Active Player',                  order: 300, isSystem: true, bg: '#f0fdf4', color: '#22c55e' },
  { key: 'alumni',                  label: 'Alumni, Departed',               order: 400, isSystem: true, bg: '#f8fafc', color: '#64748b' },
  { key: 'withdrawn',               label: 'Withdrew',                       order: 500, isSystem: true, bg: '#fef2f2', color: '#ef4444' },
];

export const STAGE_MAP = Object.fromEntries(STAGES.map((s) => [s.key, s]));

// Every entry here is an unconditional write-target of automation that
// doesn't consult an academy's stage list first — contractSigned (default
// player-creation stage), paymentMade (auto-advance on a deposit invoice
// being paid), and the two agency-placement stages (see the comment block
// above and functions/index.js assignPlayerToAcademy/unassignPlayer).
// Hiding one wouldn't stop the write, just make the result vanish from the
// board. Mirrors PROTECTED_SYSTEM_STAGES.player in functions/index.js —
// keep in sync.
export const PROTECTED_PLAYER_STAGE_KEYS = ['contractSigned', 'paymentMade', 'unassigned', 'awaitingAcademyContract'];

export function stageLabel(key) {
  return STAGE_MAP[key]?.label ?? key;
}
